var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "items main-content" }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "d-flex flex-row" }, [
        _c("div", [
          _c("h3", { staticClass: "page-title" }, [
            _vm._v(_vm._s(_vm.$tc("backups.backup", 2))),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("ol", { staticClass: "breadcrumb" }, [
        _c(
          "li",
          { staticClass: "breadcrumb-item" },
          [
            _c(
              "router-link",
              {
                attrs: { slot: "item-title", to: "dashboard" },
                slot: "item-title",
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("general.home")) + "\n        "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          { staticClass: "breadcrumb-item" },
          [
            _c(
              "router-link",
              { attrs: { slot: "item-title", to: "#" }, slot: "item-title" },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$tc("backups.backup", 2)) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "page-actions row" }, [
        _c(
          "div",
          {
            staticClass: "col-xs-2",
            attrs: { slot: "item-title" },
            slot: "item-title",
          },
          [
            _c(
              "base-button",
              {
                attrs: { color: "theme", icon: "plus", size: "large" },
                on: {
                  click: function ($event) {
                    return _vm.newBackup()
                  },
                },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("backups.add_backup")) +
                    "\n        "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showEmptyScreen,
            expression: "showEmptyScreen",
          },
        ],
        staticClass: "col-xs-1 no-data-info",
        attrs: { align: "center" },
      },
      [
        _c("satellite-icon", { staticClass: "mt-5 mb-4" }),
        _vm._v(" "),
        _c("div", { staticClass: "row", attrs: { align: "center" } }, [
          _c("label", { staticClass: "col title" }, [
            _vm._v(_vm._s(_vm.$t("backups.no_backups"))),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row" }, [
          _c(
            "label",
            { staticClass: "description col mt-1", attrs: { align: "center" } },
            [_vm._v(_vm._s(_vm.$t("backups.list_of_backups")))]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btn-container" },
          [
            _c(
              "base-button",
              {
                staticClass: "mt-3",
                attrs: { outline: true, color: "theme", size: "large" },
                on: {
                  click: function ($event) {
                    return _vm.newBackup()
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("backups.add_new_backup")) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.showEmptyScreen,
            expression: "!showEmptyScreen",
          },
        ],
        staticClass: "table-container",
      },
      [
        _c(
          "div",
          { staticClass: "table-actions mt-5" },
          [
            _c("p", { staticClass: "table-stats" }, [
              _vm._v("\n        " + _vm._s(_vm.$t("general.showing")) + ": "),
              _c("b", [_vm._v(_vm._s(_vm.backups.length))]),
              _vm._v("\n        " + _vm._s(_vm.$t("general.of")) + " "),
              _c("b", [_vm._v(_vm._s(_vm.totalBackups))]),
            ]),
            _vm._v(" "),
            _c(
              "transition",
              { attrs: { name: "fade" } },
              [
                _vm.selectedBackups.length
                  ? _c(
                      "v-dropdown",
                      { attrs: { "show-arrow": false } },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "table-actions-button dropdown-toggle",
                            attrs: { slot: "activator", href: "#" },
                            slot: "activator",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("general.actions")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("v-dropdown-item", [
                          _c(
                            "div",
                            {
                              staticClass: "dropdown-item",
                              on: { click: _vm.removeMultipleBackups },
                            },
                            [
                              _c("font-awesome-icon", {
                                staticClass: "dropdown-item-icon",
                                attrs: { icon: ["fas", "trash"] },
                              }),
                              _vm._v(
                                "\n              " +
                                  _vm._s(_vm.$t("general.delete")) +
                                  "\n            "
                              ),
                            ],
                            1
                          ),
                        ]),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "custom-control custom-checkbox" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectAllFieldStatus,
                expression: "selectAllFieldStatus",
              },
            ],
            staticClass: "custom-control-input",
            attrs: { id: "select-all", type: "checkbox" },
            domProps: {
              checked: Array.isArray(_vm.selectAllFieldStatus)
                ? _vm._i(_vm.selectAllFieldStatus, null) > -1
                : _vm.selectAllFieldStatus,
            },
            on: {
              change: [
                function ($event) {
                  var $$a = _vm.selectAllFieldStatus,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = null,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.selectAllFieldStatus = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.selectAllFieldStatus = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.selectAllFieldStatus = $$c
                  }
                },
                _vm.selectAllBackups,
              ],
            },
          }),
          _vm._v(" "),
          _c(
            "label",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.isRequestOngoing,
                  expression: "!isRequestOngoing",
                },
              ],
              staticClass: "custom-control-label selectall",
              attrs: { for: "select-all" },
            },
            [
              _c("span", { staticClass: "select-all-label" }, [
                _vm._v(_vm._s(_vm.$t("general.select_all")) + " "),
              ]),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "table-component",
          {
            ref: "table",
            attrs: {
              data: _vm.fetchData,
              "show-filter": false,
              "table-class": "table",
            },
          },
          [
            _c("table-column", {
              attrs: {
                sortable: false,
                filterable: false,
                "cell-class": "no-click",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (row) {
                    return [
                      _c(
                        "div",
                        { staticClass: "custom-control custom-checkbox" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectField,
                                expression: "selectField",
                              },
                            ],
                            staticClass: "custom-control-input",
                            attrs: { id: row.file_name, type: "checkbox" },
                            domProps: {
                              value: row.file_name,
                              checked: Array.isArray(_vm.selectField)
                                ? _vm._i(_vm.selectField, row.file_name) > -1
                                : _vm.selectField,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectField,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = row.file_name,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectField = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectField = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectField = $$c
                                }
                              },
                            },
                          }),
                          _vm._v(" "),
                          _c("label", {
                            staticClass: "custom-control-label",
                            attrs: { for: row.file_name },
                          }),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: { label: _vm.$t("backups.file_name"), show: "file_name" },
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: { label: _vm.$t("backups.file_size"), show: "file_size" },
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: {
                label: _vm.$t("backups.added_on"),
                show: "last_modified",
              },
            }),
            _vm._v(" "),
            _c("table-column", {
              attrs: {
                sortable: false,
                filterable: false,
                "cell-class": "action-dropdown",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (row) {
                    return [
                      _c("span", [
                        _vm._v(" " + _vm._s(_vm.$t("backups.actions")) + " "),
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-dropdown",
                        [
                          _c(
                            "a",
                            {
                              attrs: { slot: "activator", href: "#" },
                              slot: "activator",
                            },
                            [_c("dot-icon")],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-dropdown-item", [
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.downloadedBackup(row.file_name)
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "dropdown-item-icon",
                                  attrs: { icon: "download" },
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("backups.download")) +
                                    "\n              "
                                ),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("v-dropdown-item", [
                            _c(
                              "div",
                              {
                                staticClass: "dropdown-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeBackup(row.file_name)
                                  },
                                },
                              },
                              [
                                _c("font-awesome-icon", {
                                  staticClass: "dropdown-item-icon",
                                  attrs: { icon: ["fas", "trash"] },
                                }),
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.$t("general.delete")) +
                                    "\n              "
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }